export default __webpack_public_path__ + "static/media/NotoSansSC-Regular.1e348b3a.ttf";